const areSameContactLenses = (serverLineItem, draftLineItem)=>{
    var ref, ref1, ref2;
    if (draftLineItem.type !== 'contact-lenses' || ((ref = serverLineItem.typeDetails) === null || ref === void 0 ? void 0 : ref.__typename) !== 'ContactLensesTypeDetails') {
        return false;
    }
    // A Contact Lens is only considered the same product when the eyeside matches as well
    return serverLineItem.sku === draftLineItem.sku && ((ref1 = serverLineItem.typeDetails) === null || ref1 === void 0 ? void 0 : ref1.eyeSide) === ((ref2 = draftLineItem.typeDetails.eyeSide) === null || ref2 === void 0 ? void 0 : ref2.toUpperCase());
};

export { areSameContactLenses };
//# sourceMappingURL=are-same-contact-lenses.js.map
